function currentUser() {
  return localStorage.getItem('username') || '';
}

function tabsKey(username) {
  const user = username || currentUser();
  return user ? `inner-tabs:${user}` : 'inner-tabs';
}

function activeTabKey(username) {
  const user = username || currentUser();
  return user ? `inner-active-tab:${user}` : 'inner-active-tab';
}

export function readTabs(username) {
  try {
    return JSON.parse(localStorage.getItem(tabsKey(username)) || '[]');
  } catch {
    return [];
  }
}

export function readActiveTab(username) {
  return localStorage.getItem(activeTabKey(username)) || '';
}

export function writeTabs(tabs, username) {
  const user = username || currentUser();
  if (!user) return;
  localStorage.setItem(tabsKey(user), JSON.stringify(tabs));
}

export function writeActiveTab(id, username) {
  const user = username || currentUser();
  if (!user) return;
  if (id) {
    localStorage.setItem(activeTabKey(user), id);
  } else {
    localStorage.removeItem(activeTabKey(user));
  }
}

export function clearLegacyTabs() {
  localStorage.removeItem('inner-tabs');
  localStorage.removeItem('inner-active-tab');
}
